import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Container,
  IconButton,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Proyek() {
  // ================= API LAMA =================
  const old_url = Config.api_domain + "/proyek/active/";
  const [oldList, setOldList] = useState([]);

  // ================= API BARU (ULANG) =================
  const new_url = Config.api_domain + "/proyek1/active/";
  const [newList, setNewList] = useState([]);

  useEffect(() => {
    const fetchOld = async () => {
      try {
        const res = await fetch(old_url);
        const data = await res.json();
        setOldList(data.data || []);
      } catch (err) {
        console.error("Old API error:", err);
      }
    };

    const fetchNew = async () => {
      try {
        const res = await fetch(new_url);
        const data = await res.json();
        setNewList(data.data || []);
      } catch (err) {
        console.error("New API error:", err);
      }
    };

    fetchOld();
    fetchNew();
  }, []);

  // ================= RENDER TABLE =================
  const renderRows = (data, downloadPath) => {
    if (data.length > 0) {
      return data.map((row, index) => {
        const dateISO = new Date(row.time_uploaded);
        const formattedDate = dateToStringDate(dateISO);

        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formattedDate}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                component="a"
                href={`${Config.api_domain}/${downloadPath}/${row.public_id}`}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    }

    return (
      <StyledTableRow>
        <StyledTableCell colSpan={4} align="center">
          No Data Found
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>
        <h2>Project Management</h2>
<h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          The objective of this consultancy is to provide a qualified Project Management Expert who will :
<br></br><br></br>a.  Enhance the quality of ILASP project planning.
<br></br>b.  Assist in team coordination, geospatial data management, and regulatory compliance.
<br></br>c.  Provide regular monitoring and evaluation reports.
        </p>
        {/* ================================================= */}
        {/* 1️⃣ ANNOUNCEMENT (ULANG - API proyek1) */}
        {/* ================================================= */}
        <h3>Announcement (Updated)</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderRows(newList, "proyek1/download")}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ================================================= */}
        {/* 2️⃣ PROCUREMENT TIMELINE (ULANG - API proyek1) */}
        {/* ================================================= */}
        {/* ================================================= */}
{/* PROCUREMENT TIMELINE (UPDATED - API PROYEK1) */}
{/* ================================================= */}
<h3>Procurement Timeline (Updated)</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table>
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>

      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>
          Publication of the REoI, TOR & Timeline
        </StyledTableCell>
        <StyledTableCell>
          23 February 2026, 08:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          06 March 2026, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>
          Clarification and addenda to the REoI and TOR
        </StyledTableCell>
        <StyledTableCell>
          24 February 2026, 08:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          25 February 2026, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>
          Submission of expressions of Interests (EoI)
        </StyledTableCell>
        <StyledTableCell>
          23 February 2026, 08:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          06 March 2026, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>
          Evaluation of Expression of Interest
        </StyledTableCell>
        <StyledTableCell>
          09 March 2026, 08:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          10 March 2026, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>
          Interview
        </StyledTableCell>
        <StyledTableCell>
          11 March 2026, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          12 March 2026, 15:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>
          Notification of Intention to Award
        </StyledTableCell>
        <StyledTableCell>
          13 March 2026, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          13 March 2026, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

    </TableBody>
  </Table>
</TableContainer>


        {/* ================================================= */}
        {/* 3️⃣ ANNOUNCEMENT LAMA (API proyek) */}
        {/* ================================================= */}
        <h3>Announcement</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderRows(oldList, "proyek/download")}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ================================================= */}
        {/* 4️⃣ PROCUREMENT TIMELINE LAMA (STATIC) */}
        {/* ================================================= */}
        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table>
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>

      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>
          Publication of the REoI, TOR & Timeline (website ILASPP) + LPSE
        </StyledTableCell>
        <StyledTableCell>
          08 September 2025, 16:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          19 September 2025, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>
          Clarification and addenda to the REoI and TOR
        </StyledTableCell>
        <StyledTableCell>
          10 September 2025, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          11 September 2025, 12:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>
          Submission of expressions of Interests (EoI)
        </StyledTableCell>
        <StyledTableCell>
          08 September 2025, 16:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          19 September 2025, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>
          Evaluation of Expression of Interest
        </StyledTableCell>
        <StyledTableCell>
          22 September 2025, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          24 September 2025, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>
          Interview & Evaluation Results
        </StyledTableCell>
        <StyledTableCell>
          25 September 2025, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          01 October 2025, 15:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>
          Notification of Intention to Award
        </StyledTableCell>
        <StyledTableCell>
          02 October 2025, 09:00 (GMT+7)
        </StyledTableCell>
        <StyledTableCell>
          02 October 2025, 16:00 (GMT+7)
        </StyledTableCell>
      </StyledTableRow>

    </TableBody>
  </Table>
</TableContainer>
<p style={{ marginTop: "1.5em" }}>
  Clarifications and Addenda to the REoI and TOR and Submission of Expressions 
  of Interest (EOI) may be submitted via email to :{" "}
  <a
    href="mailto:proyek.ilasp@big.go.id"
    style={{ color: "#1976d2", textDecoration: "underline" }}
  >
    proyek.ilasp@big.go.id
  </a>
</p>

      </Container>
    </div>
  );
}

export default Proyek;
